module.exports = __webpack_public_path__ + "img/accounting-general-ledger.d53d2b41.svg";